import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store/store';
import { setPaymentMode } from 'store/ticket-service/ticketSlice';
import { setNotEnoughTokensError } from 'store/user-service/userSlice';

import { NamespacesList } from 'core/enums/common';

import { SharedModal } from 'components/shared/Modal';

import { ReactComponent as Error } from 'assets/icons/error.svg';

export const NotEnoughTokensModal = () => {
	const { t: paymentTranslate } = useTranslation(NamespacesList['payment']);

	const dispatch = useAppDispatch();
	const [open, setOpen] = useState<boolean>(true);

	const handleClose = () => {
		setOpen(false);
		dispatch(setNotEnoughTokensError(false));
	};

	const handlePaymentModalRedirect = () => {
		setOpen(false);
		dispatch(setPaymentMode(true));
		dispatch(setNotEnoughTokensError(false));
	};

	return (
		<SharedModal isOpen={open} handleClose={handleClose}>
			<Box
				className="not-rtl-able"
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					alignSelf: 'center',
					width: { xs: '100%', sm: '438px' },
					margin: '48px 0',
				}}
			>
				<Error />

				<Typography variant="h3" sx={{ fontSize: '24px', fontWeight: '700', marginTop: '32px' }}>
					{paymentTranslate('modals.notEnoughTokens.title')}
				</Typography>

				<Typography
					sx={{
						color: '#9FA6B3',
						marginTop: '8px',
						textAlign: 'center',
					}}
				>
					{paymentTranslate('modals.notEnoughTokens.description')}
				</Typography>

				<Box
					className="not-rtl-able"
					sx={{
						width: { xs: '90%', sm: '100%' },
						display: 'flex',
						justifyContent: 'space-between',
						gap: { xs: '0', sm: '16px' },
					}}
				>
					<Button
						sx={{
							height: '44px',
							width: { xs: '49%', sm: '215px' },
							borderRadius: '8px',
							textTransform: 'none',
							fontSize: '16px',
							fontWeight: '700',
							marginTop: '24px',
						}}
						variant="outlined"
						color="primary"
						onClick={handleClose}
					>
						{paymentTranslate('modals.notEnoughTokens.decline')}
					</Button>

					<Button
						sx={{
							height: '44px',
							width: { xs: '49%', sm: '215px' },
							borderRadius: '8px',
							textTransform: 'none',
							fontSize: '16px',
							fontWeight: '700',
							marginTop: '24px',
						}}
						variant="contained"
						color="primary"
						onClick={handlePaymentModalRedirect}
					>
						{paymentTranslate('modals.notEnoughTokens.confirm')}
					</Button>
				</Box>
			</Box>
		</SharedModal>
	);
};
